import React from 'react'
import { useDispatch } from 'react-redux'
import { MdOutlineDelete } from 'react-icons/md'
import { deleteAboutMember } from '../../../../entity/about-member/AboutMember'
import { getAboutSection } from '../../../../entity/about-sections/AboutSection'

const DeleteMember = ({ memberId }) => {
  const dispatch = useDispatch()

  const deleteAboutMemberHanlder = async memberId => {
    const confirmed = window.confirm('Do you want to delete this member?')

    if (confirmed) {
      try {
        await dispatch(deleteAboutMember({ memberId }))
        await dispatch(getAboutSection())
      } catch (error) {
        console.error('Failed to delete member:', error)
      }
    } else {
      console.log('Delete action canceled')
    }
  }

  return (
    <MdOutlineDelete
      className='opacity-0 group-hover:opacity-100 my-2 text-4xl hover:scale-110 transition-all cursor-pointer text-[#326383] absolute top-0 left-12 border-2 border-[#326383] rounded-full p-1 bg-slate-100'
      onClick={() => deleteAboutMemberHanlder(memberId)}
    />
  )
}

export default DeleteMember
